// extracted by mini-css-extract-plugin
export default {"container":"IWAKjx","title":"eaaL62","templates":"mi_0A2","templateImg":"rUBPWn"};